import './i18n';
import 'react-tooltip/dist/react-tooltip.css';
import { AnalyticsProvider } from 'use-analytics';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'ui/components/ErrorBoundary';
import { ErrorManagerProvider } from 'ui/components/ErrorManager';
import { fakeDataConfig } from 'utils/fakeDataConfig';
import { lazy, Suspense, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { setTheme } from 'theme/setTheme';
import {
  TestingContextProvider,
  TestingTools,
} from 'ui/components/TestingProvider';
import { theme } from 'theme/theme';
import analyticsInstance from 'analyticsInstance';
import AuthProvider from 'ui/components/AuthProvider';
import initDatadogLogs from './datadog/logs';
// import initDatadogRUM from './datadog/rum';
import DataLayer from 'ui/components/DataLayer';
import isDevEnv from 'utils/isDevEnv';
import isProduction from 'utils/isProduction';
import LoginFlowProvider from 'ui/components/LoginFlowProvider';
import RedirectToDashboardProvider from 'ui/components/RedirectToDashboardProvider';
import Routes from './ui/Routes';

const queryClient = new QueryClient();

const LazyBuildInfo = lazy(() => import('./utils/BuildInfo'));

export default function AppComponent() {
  if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'production') {
    // initDatadogRUM();
    initDatadogLogs();
  }

  useEffect(() => {
    setTheme(theme);
  }, []);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider instance={analyticsInstance}>
          <RedirectToDashboardProvider>
            <ErrorManagerProvider>
              <ErrorBoundary>
                <TestingContextProvider>
                  <AuthProvider>
                    <LoginFlowProvider>
                      <DataLayer />
                      <Routes />
                      {!isProduction() && (
                        <TestingTools fakeData={fakeDataConfig} />
                      )}
                      <Suspense fallback={null}>
                        {isDevEnv() && <LazyBuildInfo />}
                      </Suspense>
                    </LoginFlowProvider>
                  </AuthProvider>
                </TestingContextProvider>
              </ErrorBoundary>
            </ErrorManagerProvider>
          </RedirectToDashboardProvider>
        </AnalyticsProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
